module.exports = __webpack_public_path__ + "img/5g.88e61665.png";